module.exports = __webpack_public_path__ + "media/images/mainova-logo-blue-b38928bec2c63d8a083814ae41ee21b8.svg";